import { Button, Card, Col, DatePicker, Form, Image, Input, List, Modal, Radio, Row, Select, Tag, TreeSelect, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { PlusOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
const { SHOW_PARENT } = TreeSelect;
const { RangePicker } = DatePicker;

function FormWarrantyClaim() {
    const token = useSelector((state) => state.user.token);
    const navigate = useNavigate();
    const location = useLocation();
    const [form] = Form.useForm();
    const [formProduct] = Form.useForm();
    const [imageUrl, setImageUrl] = useState();
    const [file, setFile] = useState();
    const [isModal, setIsModal] = useState(false);
    const dateFormat = 'YYYY-MM-DD';
    //store
    const [store, setStore] = useState([]);
    const [userMember, setUserMember] = useState([]);
    const [userTech, setUserTech] = useState([]);
    const [product, setProduct] = useState([]);
    const [serviceCenter, setServiceCenter] = useState([]);
    const [load, setLoad] = useState(0);
    const [warranty, setWarranty] = useState([]);
    const [warrantySelected, setWarrantySelected] = useState();

    //image
    const [imageWarranty, setImageWarranty] = useState();
    const [imageReceipt, setImageReceipt] = useState();
    const [fileWarranty, setFileWarranty] = useState();
    const [fileReceipt, setFileReceipt] = useState();

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    const uploadImage = (info, type) => {
        if (type === 'warranty') {
            setFileWarranty(info.file);
            getBase64(info.file, (url) => {
                setImageWarranty(url);
            });
        } else {
            setFileReceipt(info.file);
            getBase64(info.file, (url) => {
                setImageReceipt(url);
            });
        }
    };

    const save = (ev) => {
        var ws = JSON.parse(warrantySelected);
        const state = location.state;
        var method = 'POST';

        //params
        ev.UserId = Number(ev.UserId);
        ev.UserTechId = Number(ev.UserTechId);
        ev.WarrantyId = ws.WarrantyId;
        ev.ProductId = ws.ProductId;
        ev.StoreId = ws.StoreId;
        // ev.SerialNumber = ws.SerialNumber;
        console.log(ev);
        if (state != null) {
            ev.ClaimId = state.item.ClaimId;
            method = "PUT";
        } else {
            method = "POST";
        }
        postApi(method, '/warrantyclaim', ev, 'claim');
    }

    const postApi = async (method, url, values, type) => {
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': type === 'warranty' ? 'multipart/form-data' : 'application/json',
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                if (type === 'warranty')
                    closeModal();
                else
                    navigate(-1);
            } else {
                modalError(res.message);
            }
        }).catch((e) => {
            console.log(e);
        })
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </div>
    );

    useEffect(() => {
        if (location.state != null) {
            const item = location.state.item;
            form.setFieldsValue({
                GuaranteeCardNo: item.GuaranteeCardNo,
                BuyingDate: item.BuyingDate,
                Problem: item.Problem,
                Solution: item.Solution,
                ServiceCenterId: Number(item.ServiceCenterId),
                UserTechId: Number(item.UserTechId),
                ViaPengiriman: item.ViaPengiriman,
                UserId: item.UserId.toString(),
                StatusToko: item.StatusToko
            });
            checkWarranty(Number(item.UserId));
        }
        getApi('GET', '/productwarrantynopage', 'productwarrant');
        getApi("GET", '/storenopage', 'store');
        getApi("GET", '/usernopage?role=3', 'membership');
        getApi("GET", '/usernopage?role=6', 'technical');
        getApi("GET", '/servicecenternopage', 'servicecenter');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [load]);

    const getApi = (method, url, type) => {
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                switch (type) {
                    case 'store':
                        var row = [];
                        for (let i = 0; i < res.data.length; i++) {
                            row.push({
                                value: res.data[i].StoreId,
                                label: res.data[i].StoreName,
                            });
                        }
                        setStore(row);
                        break;

                    case 'membership':
                        var row = [];
                        for (let i = 0; i < res.data.rows.length; i++) {
                            row.push({
                                value: res.data.rows[i].id,
                                label: res.data.rows[i].name,
                            });
                        }
                        setUserMember(row);
                        break;
                    case 'technical':
                        var row = [];
                        for (let i = 0; i < res.data.rows.length; i++) {
                            row.push({
                                value: res.data.rows[i].id,
                                label: res.data.rows[i].name,
                            });
                        }
                        setUserTech(row);
                        break;

                    case 'productwarrant':
                        var row = [];
                        for (let i = 0; i < res.data.length; i++) {
                            row.push({
                                value: res.data[i].ProductId,
                                label: res.data[i].ProductName,
                            });
                        }
                        setProduct(row);
                        break;

                    case 'servicecenter':
                        var row = [];
                        for (let i = 0; i < res.data.rows.length; i++) {
                            row.push({
                                value: res.data.rows[i].ServiceCenterId,
                                label: res.data.rows[i].ServiceCenter,
                            });
                        }
                        setServiceCenter(row);
                        break;
                    case 'warranty':
                        if (res.data !== null) {
                            if (location.state != null) {
                                const item = location.state.item;
                                for (let i = 0; i < res.data.rows.length; i++) {
                                    if(res.data.rows[i].WarrantyId === item.WarrantyId){
                                        setWarrantySelected(JSON.stringify(res.data.rows[i]));
                                    }
                                }
                            }
                            setWarranty(res.data.rows);
                        } else {
                            setWarranty([]);
                        }
                        break;
                }
            } else {
                console.log(res.message);
            }
        }).catch((e) => {
            console.log(e.message);
        })
    }

    const closeModal = () => {
        setIsModal(false);
        setImageReceipt(null);
        setImageWarranty(null);
        formProduct.resetFields();
    }

    const onFinish = (ev) => {
        const form = new FormData();
        for (const name in ev) {
            form.append(name, ev[name]);
        }
        postApi('POST', '/warranty', form, 'warranty');
    }

    const checkWarranty = (user_id) => {
        setWarrantySelected(null);
        getApi("GET", '/warranty?UserId=' + user_id, 'warranty');
    }

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="primary" onClick={form.submit} size='large' >
                    <b style={{ marginLeft: 5 }}>Simpan</b>
                </Button>
            </div>
            <Form form={form} name="form_store" layout="vertical" onFinish={save}>
                <Row>
                    <Col span={20}>
                        <Form.Item
                            name="UserId"
                            label="Nama Membership"
                            rules={[
                                {
                                    required: true,
                                    message: 'Nama Membership kosong!'
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder="Pilih Membership"
                                optionFilterProp="children"
                                filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={userMember}
                                onChange={(ev) => checkWarranty(ev)}
                                style={{ marginRight: 10, width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Button style={{ marginLeft: 10, marginTop: 25, width: "100%" }} type="primary" onClick={() => setIsModal(true)} size='large' >
                            <b style={{ marginLeft: 5 }}>Tambah Garansi</b>
                        </Button>
                    </Col>
                </Row>
                <Form.Item
                    label="Pilih Garansi"
                    rules={[
                        {
                            required: true,
                            message: 'Garansi Produk kosong!'
                        },
                    ]}
                >
                    {
                        warranty.length > 0 ?

                            <List
                                grid={{
                                    gutter: 16,
                                    column: 4,
                                }}
                                dataSource={warranty}
                                renderItem={(item) => (
                                    <List.Item onClick={(ev) => setWarrantySelected(JSON.stringify(item))}>
                                        <Card title={'No. Garansi : ' + item.GuaranteeCardNo} style={{ border: warrantySelected === JSON.stringify(item) ? '3px solid red' : '1px solid #F2F2F2' }}>
                                            <Row>
                                                <Image
                                                    style={{ marginRight: 10 }}
                                                    width={70}
                                                    height={70}
                                                    fallback="data:image/png;base64,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"
                                                    src={item.Product.ProductImage} />
                                                <Image
                                                    style={{ marginRight: 10 }}
                                                    width={70}
                                                    height={70}
                                                    fallback="data:image/png;base64,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"
                                                    src={item.PurchaseReceipt} />
                                                <Image
                                                    style={{ marginRight: 10 }}
                                                    width={70}
                                                    height={70}
                                                    fallback="data:image/png;base64,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"
                                                    src={item.ImageWarranty} />
                                            </Row>
                                            <p>Nama Produk : {item.Product.ProductName}</p>
                                            <p>Tanggal pembelian : {item.PurchaseDate}</p>
                                            <p>Nama Pelanggan : {item.user != null && item.user.name}</p>
                                            <p>Nama Toko : {item.Store != null && item.Store.StoreName}</p>
                                        </Card>
                                    </List.Item>
                                )}
                            />
                            :
                            <Tag color="red">Belum ada Garansi</Tag>
                    }
                </Form.Item>
                <Form.Item
                    name="Problem"
                    label="Permasalahan / Kendala"
                    rules={[
                        {
                            required: true,
                            message: 'Permasalahan / Kendala kosong!'
                        },
                    ]}
                >
                    <Input.TextArea placeholder='Permasalahan / Kendala' autoSize={true} />
                </Form.Item>
                <Form.Item
                    name="Solution"
                    label="Solusi"
                    rules={[
                        {
                            required: true,
                            message: 'Solusi kosong!'
                        },
                    ]}
                >
                    <Input.TextArea placeholder='Solusi' autoSize={true} />
                </Form.Item>
                <Form.Item
                    name="ServiceCenterId"
                    label="Service Center"
                    rules={[
                        {
                            required: true,
                            message: 'Service Center kosong!'
                        },
                    ]}
                >
                    <Select
                        showSearch
                        placeholder="Pilih Service Center"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={serviceCenter}
                        style={{ marginRight: 10, width: '100%' }}
                    />
                </Form.Item>
                <Form.Item
                    name="UserTechId"
                    label="Pilih Teknisi"
                    rules={[
                        {
                            required: true,
                            message: 'Teknisi kosong!'
                        },
                    ]}
                >
                    <Select
                        showSearch
                        placeholder="Pilih Teknisi"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={userTech}
                        style={{ marginRight: 10, width: '100%' }}
                    />
                </Form.Item>
                <Form.Item
                    name="ViaPengiriman"
                    label="Via Pengiriman"
                    rules={[
                        {
                            required: true,
                            message: 'Solusi kosong!'
                        },
                    ]}
                >
                    <Input placeholder='*Example : JNE, JNT, MPXGo, other' autoSize={true} />
                </Form.Item>
            </Form>


            {/* warranty produk */}
            <Modal title="Form Garansi Produk" open={isModal} onOk={formProduct.submit} onCancel={() => closeModal()} okText="Simpan" >
                <Form form={formProduct} name="form" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="UserId"
                        label="Nama Membership"
                        rules={[
                            {
                                required: true,
                                message: 'Nama Membership kosong!'
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Pilih Memberhsip"
                            optionFilterProp="children"
                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            options={userMember}
                            style={{ marginRight: 10, width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="ProductId"
                        label="Produk"
                        rules={[
                            {
                                required: true,
                                message: 'Produk kosong!'
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Pilih Produk"
                            optionFilterProp="children"
                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            options={product}
                            style={{ marginRight: 10, width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="StoreId"
                        label="Toko"
                        rules={[
                            {
                                required: true,
                                message: 'Toko kosong!'
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Pilih Toko"
                            optionFilterProp="children"
                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            options={store}
                            style={{ marginRight: 10, width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="GuaranteeCardNo"
                        label="Nomor Kartu Garansi"
                        rules={[
                            {
                                required: true,
                                message: 'Nomor Kartu Garansi kosong!'
                            },
                        ]}

                    >
                        <Input autoSize={true} placeholder='Nomor Kartu Garansi' />
                    </Form.Item>
                    <Form.Item
                        name="BuyingDate"
                        label="Tanggal Pembelian"
                        rules={[
                            {
                                required: true,
                                message: 'Tanggal Pembelian kosong!'
                            },
                        ]}
                    >
                        <DatePicker
                            placeholder='Pilih Tanggal Pembelian'
                            picker='date'
                            style={{
                                width: '100%'
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="PurchaseReceipt"
                        label="Foto Struk Pembelian"
                        rules={[
                            {
                                required: false,
                                message: 'Foto Struk Pembelian kosong!'
                            },
                        ]}
                    >
                        <Upload
                            listType="picture-card"
                            showUploadList={false}
                            onChange={(ev) => uploadImage(ev, 'receipt')}
                            beforeUpload={() => false}
                        >
                            {imageReceipt ? (
                                <img
                                    src={imageReceipt}
                                    alt="avatar"
                                    style={{ height: 100, width: 100, borderRadius: 10 }}
                                />
                            ) : (
                                uploadButton
                            )}
                        </Upload>
                    </Form.Item>
                    <Form.Item
                        name="ImageWarranty"
                        label="Garansi Produk Pembelian"
                        rules={[
                            {
                                required: false,
                                message: 'Garansi Produk kosong!'
                            },
                        ]}
                    >
                        <Upload
                            listType="picture-card"
                            showUploadList={false}
                            onChange={(ev) => uploadImage(ev, 'warranty')}
                            beforeUpload={() => false}
                        >
                            {imageWarranty ? (
                                <img
                                    src={imageWarranty}
                                    alt="avatar"
                                    style={{ height: 100, width: 100, borderRadius: 10 }}
                                />
                            ) : (
                                uploadButton
                            )}
                        </Upload>
                    </Form.Item>

                </Form>
            </Modal>
        </div>
    );
}

export default FormWarrantyClaim;